import { ListServiceParams, ListServiceResult } from './services'

export enum StatusCodes {
  OK = 200,
  CREATED = 201,
  NO_CONTENT = 204,

  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  BAD_REQUEST = 400,
  NOT_FOUND = 404,
  UNPROCESSABLE_ENTITY = 422,
  INTERNAL = 500
}

export interface ApiServiceParams<RequestData> {
  resource: string
  method: 'delete' | 'get' | 'patch' | 'post' | 'put'
  url: string
  baseURL?: string
  params?: RequestData
  body?: RequestData
  headers?: Record<string, unknown>
  ignoreRefreshing?: boolean
}

export interface ApiServiceResult<ResponseData> {
  headers: Record<string, string>
  data: ResponseData
}

export interface ListApiParams extends ListServiceParams {}

export interface ListApiResult<Model = any> extends ListServiceResult<Model> {}
